import { MIN_LEDGER_SAVINGS, PAID_RUN_WINDOW } from "../constants.dashboard";
import {
  TResolveYearlyUpsaleVariantParams,
  TYearlyUpsaleVariant,
} from "../types.dashboard";
import { computePaidRun } from "./computePaidRun";
import { isLedgerEligible } from "./isLedgerEligible";
import { toLedgerAmounts } from "./toLedgerAmounts";

const BANNER: TYearlyUpsaleVariant = { kind: "banner" };

/** Ledger for eligible users with a recent paid monthly run and real savings; banner otherwise */
export function resolveYearlyUpsaleVariant({
  estimate,
  invoices = [],
  ...eligibility
}: TResolveYearlyUpsaleVariantParams): TYearlyUpsaleVariant {
  if (!(isLedgerEligible(eligibility) && estimate)) {
    return BANNER;
  }

  const paidRun = computePaidRun(invoices, PAID_RUN_WINDOW);
  if (paidRun.length === 0) {
    return BANNER;
  }

  const amounts = toLedgerAmounts(estimate, paidRun);
  // A discounted monthly price can undercut yearly; never pitch a token saving
  const hasSavings =
    amounts.savedSoFar > MIN_LEDGER_SAVINGS &&
    amounts.savedPerYear > MIN_LEDGER_SAVINGS;

  return hasSavings ? { kind: "ledger", amounts, estimate } : BANNER;
}
